export default "__VITE_ASSET__C_t8bykd__"